import { render, staticRenderFns } from "./PullRefresh.vue?vue&type=template&id=20f69a42&scoped=true"
import script from "./PullRefresh.vue?vue&type=script&lang=ts"
export * from "./PullRefresh.vue?vue&type=script&lang=ts"
import style0 from "./PullRefresh.vue?vue&type=style&index=0&id=20f69a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f69a42",
  null
  
)

export default component.exports